import { MyUploadWrapper } from "Components/MyUpload/MyUpload";
import React from "react";
import { parseExcel } from "./helpers/excelParcer";
import { successNotification } from "Components/MyNotification";
import { Checkbox } from "antd";

export const MaterialsSettings = ({
  disabled,
  setProjectMaterials,
  setOpenMaterialsWorkTypeSetter,
}) => {
  return (
    <>
      <Checkbox
        disabled={disabled}
        onChange={(e) => setOpenMaterialsWorkTypeSetter(e.target.checked)}
      >
        Призначити роботи під матеріали
      </Checkbox>
      <MyUploadWrapper
        disabled={disabled}
        multiple
        btnText={"Завантажте матеріали"}
        resetOnSelect={true}
        customOnChange={async (fileList) => {
          const files = fileList.map((f) => f.originFileObj).filter(Boolean);
          const result = await parseExcel(files);
          if (result.length) {
            successNotification("Матеріали занесені в таблицю");
            setProjectMaterials(result);
          }
        }}
      />
    </>
  );
};
